import { render, staticRenderFns } from "./VideoFileSelect.vue?vue&type=template&id=b265b638&scoped=true"
import script from "./VideoFileSelect.vue?vue&type=script&lang=js"
export * from "./VideoFileSelect.vue?vue&type=script&lang=js"
import style0 from "./VideoFileSelect.vue?vue&type=style&index=0&id=b265b638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b265b638",
  null
  
)

export default component.exports